import { ref, computed, watch, Ref } from "vue";

export function useChallengeForm() {
  // ===================================================================
  // STATE
  // ===================================================================
  const challenged = ref<number>(1);
  const weight = ref<number>(0);
  const comment = ref<string>("");
  const successMessage: Ref<string> = ref("");
  const isProgrammaticChange: Ref<boolean> = ref(false);
  const challengeDuration = ref<number>(0);

  // ===================================================================
  // COMPUTED
  // ===================================================================
  const isWeightDisabled = computed(() => challenged.value && challenged.value > 1);
  const isChallengedDisabled = computed(() => !!weight.value && challenged.value === 1);
  const canSave = computed(() => challenged.value && challenged.value > 0);

  // ===================================================================
  // ACTIONS - Form Operations
  // ===================================================================
  const incrementChallenged = () => {
    if (isChallengedDisabled.value) return;
    challenged.value = (challenged.value || 0) + 1;
    validateChallenged();
  };

  const decrementChallenged = () => {
    if (isChallengedDisabled.value) return;
    if (challenged.value && challenged.value > 1) {
      challenged.value--;
      validateChallenged();
    }
  };

  const resetForm = () => {
    challenged.value = 1;
    weight.value = 0;
    challengeDuration.value = 0;
    comment.value = "";
    successMessage.value = "✓";
    isProgrammaticChange.value = true;
  };

  // ===================================================================
  // VALIDATORS - Form Rules
  // ===================================================================
  const validateChallenged = () => {
    if (challenged.value && challenged.value > 1) {
      weight.value = 0;
    }
  };

  // ===================================================================
  // WATCHERS - Cross-field Dependencies
  // ===================================================================
  watch([challenged, weight, challengeDuration, comment], () => {
    if (!isProgrammaticChange.value) {
      successMessage.value = "";
    }
    isProgrammaticChange.value = false;
  });

  watch(
    () => weight.value,
    (newWeight) => {
      if (newWeight) {
        challenged.value = 1;
      }
    }
  );

  return {
    // ===================================================================
    // STATE
    // ===================================================================
    challenged,
    weight,
    challengeDuration,
    comment,
    successMessage,
    isProgrammaticChange,

    // ===================================================================
    // VALIDATION
    // ===================================================================
    isWeightDisabled,
    isChallengedDisabled,
    canSave,

    // ===================================================================
    // ACTIONS
    // ===================================================================
    incrementChallenged,
    decrementChallenged,
    resetForm,
    validateChallenged
  };
}